import {sizeOf} from 'shared/utils/sizeOf';

export function createPayload({history}: AppState, listIndex: number): DeleteSpendEventPayload {
  const historySize = sizeOf(history);
  return {listIndex, historySize};
}
